const countrydata = require('countrydata');
import pageRoutes from '@/libs/constant/pageRoutes'
import constants from '@/libs/constant/constants'
import {errorHandler, message, logout, loader, getCountryByCode} from '@/libs/helper'
import {
    unSubscribePlan,
    updateUserProfile,
    fetchStripeCustomerId,
    getActiveSubscription,
} from '@/libs/api/api'
import { getUserProfile } from '../../../libs/api/api';

export default{
    props:{
        userInformation: {
            type: Object,
            default: {}
        }
    },
    beforeMount(){
        this.getUserActiveSubscription()
        this.getPaymentDetails()
    },
    data(){
        return {
            countrydata,
            activePlan: [],
            card: {},
            isDialogVisible:false,
            cancelAtPeriodEnd: false, 
            invoiceDetails: {
                company: this.$store.getters.getUserInformation.company || '',
                department: this.$store.getters.getUserInformation.department || '',
                line1: this.$store.getters.getUserInformation.line1 || '',
                line2: this.$store.getters.getUserInformation.line2 || '',
                postal_code: this.$store.getters.getUserInformation.postal_code || '',
                city: this.$store.getters.getUserInformation.city || '',
                country_code: this.$store.getters.getUserInformation.country_code || '',
                country_name: this.$store.getters.getUserInformation.country_name || '',
            }
        }
    },
    created() {
        this.initialCall();
    },
    methods: {
        /*
         * navigates the user to the payment page.
         * */
        routeTo(query){
            this.$router.push(`${pageRoutes.payment}/?module=${query}`)
        },
        /*
         * getUserActiveSubscription() fetches the active plan of the user.
         * */
        getUserActiveSubscription(){
            getActiveSubscription().then((response)=> {
                this.cancelAtPeriodEnd=response.plans[0].cancel_at_period_end;  
                this.$store.dispatch('setExpiredSubscription', response.error)   
                if (response.plans.length === 0) {
                    this.activePlan.push({
                        plan: {
                            nickname: 'Not available',
                            interval: 'Not available',
                        },
                        current_period_end: 'Not available'
                    })
                } else {
                    this.activePlan = response.plans
                }
            }).catch((error)=> {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            })
        },
        /*
         * returns the billing cycle
         * */
        getBillingCycle(billingCycle){
            switch (billingCycle) {
                case 'month':
                    return 'Monthly'
                case 'year':
                    return 'Yearly'
                default:
                    return billingCycle
            }
        },
        /*
         * converts the plan end date in
         * required format "dd/mm/yy"
         * */
        getPlanEndDate (date) {
            if (date !== undefined && date !== 'Not available' && date !== 0) {
                let d = new Date(parseInt(`${date}000`))
                 return ('0' + d.getDate()).slice(-2) + '/' + ('0' + (d.getMonth() + 1)).slice(-2) + '/' + d.getFullYear()
            } else if (date === 0) {
                return 'Not available'
            } else {
                return date
            }
        },
        /*
         * cancel subscription
         * */
        cancelSubscription(){
            loader(this, true)
            unSubscribePlan(this.activePlan[0].id).then((response)=> {
                loader(this, false)
                message(this, constants.messageType.SUCCESS, (response.message))
                this.getUserActiveSubscription()
            }).catch((error)=> {
                loader(this, false)
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            })
        },
        /*
         * getPaymentDetails() calls the api to get the
         * user payment details
         * */
        getPaymentDetails(){
            fetchStripeCustomerId().then((response)=> {
                if (response.card_details && response.card_details.card) {
                    this.card = response.card_details.card
                } else {
                    this.card = {}
                }
            })
        },
        isSubscriptionExpired() {
            if (this.activePlan.length > 0 && this.activePlan[0].canceled_at && this.activePlan[0].id) {
                let subscriptionStatus = this.activePlan[0].status;
                let cancel_at_period_end=this.activePlan[0].cancel_at_period_end;
                // Check if the subscription has ended based on the current date
                let today = new Date();
                let endDate = new Date(this.activePlan[0].cancel_at * 1000); 
                return subscriptionStatus === 'active' && endDate < today && !cancel_at_period_end;
            }
            return false;
        },
        /*
         * getCardDetails() create and returns the string
         * of card information to display
         * */
        getCardDetails(card){
            if (card.last4 && card.brand) {
                return `${card.brand} (****${card.last4})`

            } else {
                return window.i18next.t('no payment method set')
            }
        },
        /*
         * manages opening and closing of
         * invoice dialog.
         * */
        manageDialog(){
            this.isDialogVisible = !this.isDialogVisible
        },
        /*
         * saveInvoiceDetails() stores the invoice details of the user
         * */
        saveInvoiceDetails(){
            loader(this, true);
            updateUserProfile(this.invoiceDetails)
                .then((response)=> {
                    if (response.id) {
                        message(this, constants.messageType.SUCCESS, 'Updated Successfully');
                        this.$store.dispatch(constants.dispatch.SET_USER_INFORMATION_TO_STORE, response);
                        this.manageDialog()
                    }
                    loader(this, false);
                })
                .catch((error)=> {
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                    loader(this, false);
                })
        },
        getLabel(){
            return `${window.i18next.t('Name on invoice')} (e.g. ${window.i18next.t('Company name')})`
        },
        initialCall () {
            loader(this, true)
            getUserProfile({}).then((res) => {
                if (res.id) {
                    this.invoiceDetails = {
                        company: res.company || '',
                        department: res.department || '',
                        line1: res.line1 || '',
                        line2: res.line2 || '',
                        postal_code: res.postal_code || '',
                        city: res.city || '',
                        country_code: res.country_code || '',
                        country_name: res.country_name || '',
                    }
                }
                loader(this, false)
            }).catch((error) => {
                console.log("catch", error)
                loader(this, false)
            })
        },
        // getCountry(code){
        //     if (code) {
        //         return countrydata.alpha2[code].iso3166.name
        //     }
        // },
        getAddress(info){
            let address = ''
            if (!info) {
                return;
            }
            
            if(info.line1 !== null && info.line1 !== undefined &&info.line1 !== ''){
                address = info.line1
            }

            if(info.line2 !== null && info.line2 !== undefined &&info.line2 !== ''){
                if(address !== ''){
                    address = `${info.line1}, ${info.line2}`
                }else{
                    address = `${info.line2}`
                }
            }

            if(info.postal_code !== null && info.postal_code !== undefined && info.postal_code !== ''){
                if(address === ''){
                    address = `${info.postal_code}`
                }else{
                    address = `${address}, ${info.postal_code}`
                }
            }
            if(info.city !== null && info.city !== undefined && info.city !== ''){
                if(address === ''){
                    address = `${info.city}`
                }else{
                    address = `${address}, ${info.city}`
                }
            }
            if(info.country_code !== null && info.country_code !== undefined && info.country_code !== ''){
                if(address === ''){
                    address = `${getCountryByCode(info.country_code)}`
                }else{
                    address = `${address}, ${getCountryByCode(info.country_code)}`
                }
            }

            return address
        }
    }
}
